import {
  reactQueryGet,
  reactQueryPost,
} from "@/react/helpers/backendRequestHelpers";
import type { AddOnQuantity, PlanAddOn } from "@/react/types/PlanAddOn";
import { internalApi } from "../helpers/urlHelpers";

interface CreateAddonsParams {
  [addonName: string]: AddOnQuantity;
}

const index = () =>
  reactQueryGet<PlanAddOn[]>(internalApi.communityPlanAddons.index());

const create = (params: CreateAddonsParams) =>
  reactQueryPost(internalApi.communityPlanAddons.create(), {
    community_plan_addons: params,
  });

export const communityPlanAddonApi = {
  index,
  create,
};
